
import React, { useContext, useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { ConfigContext } from "../context/GlobalContext";
import ExpenseListLayer from "../components/ExpenseListLayer";
import SaleReturnListLayer from "../components/SaleReturnListLayer";
import { Languages } from "../Utils/Languages";

const SalesReturnListPage = () => {

  const { state } = useContext(ConfigContext);
  const invoices = state?.INVOICES || [];

  invoices.forEach((item) => {
    const uniqueID = item?.uniqueID;
  });
  


  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title={Languages[state?.LANGUAGE]?.SaleReturn_List} />

        {/* InvoiceListLayer */}
        <SaleReturnListLayer businessData={state?.BUSINESSES} saleReturnData={state?.SALERETURN} />

      </MasterLayout>


    </>
  );
};

export default SalesReturnListPage;
